import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import UserRolesAdminList from './components/UserRolesAdminList';
import UserRolesAdminAddUserRolePage from './components/UserRolesAdminAddUserRolePage';

const UserRolesAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="User admin tabs">
        <Tab label="List User roles" />
        <Tab label="Add User role" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <UserRolesAdminList />}
        {tab === 1 && <UserRolesAdminAddUserRolePage />}
      </Box>
    </Box>
  );
};

export default UserRolesAdminPage;